<template>
  <div ref="adline" class="ad-container">
    <!-- 广告 -->
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'
import { substring } from '@/utils/index'

export default {
  name: 'AdLine',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  filters: {
    commentFilter(comment) {
      return substring(comment, 16, true)
    }
  },
  watch: {
    list() {
      this.appendScript()
    }
  },
  mounted() {
    this.appendScript()
  },
  methods: {
    toMore: function(){
      this.$emit('clickMore', this.dataId, this.dataTitle);
    },
    clickOpen: function(item){
      cblockItem(item, this)
    },
    randomNumber(){
      return parseInt(Math.random()*4900)+100
    },
    appendScript(){
      this.$refs.adline.innerHTML = ''
      for(const item of this.list) {
        if(item.redirect){
          const script = document.createElement('script');
          script.src = item.redirect;
          this.$refs.adline.append(script)
        } else {
          this.loadScript(item.comment)
        }
      }
    },
    loadScript(code) {
      code = "(function(container){"+code+"})";
      console.log('ad', code)
      try {
        const f = eval(code);
        f(this.$refs.adline)
      } catch (error) {
        console.log('方法执行错误!', error)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ad-container{
  padding: 8px 16px;
}
</style>
